import BasePage from "@Scripts/Pages/BasePage";

export default class StoreHomePage extends BasePage {
    public static async init() {
        await super.init();

        this.setHighlights();
    }

    private static setHighlights() {
        const visuals = new (<any>window).Swiper(".elements-carosel", {
            modules: [(<any>window).Pagination, (<any>window).Navigation],
            slidesPerView: "auto",
            centeredSlides: true,
            pagination: {
                el: ".slide-count",
                type: "bullets",
                clickable: false,
                renderBullet: function (index, className) {
                    return "<div class=\"item \ " + className + "\"></div>";
                }
            },
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            }
        });
    }
}